import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import { ToastrNotificationService } from '../services/toastr.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LimitReachedPopupComponent } from '../components/limit-reached-popup/limit-reached-popup.component';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
	constructor(
		private authenticationService: AuthService,
		private router: Router,
		private notificationService: ToastrNotificationService,
		private modalService: NgbModal
	) {}

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request).pipe(
			catchError(err => {
				if (401 === err.status) {
					// auto logout if 401 Unauthorized
					err.statusText = 'Unauthorized';
					this.authenticationService.logout();
				}
				if (402 === err.status) {
					const codeError = err.error.code;
					if (codeError === 'LIMIT_REACHED') {
						const modalRef = this.modalService.open(LimitReachedPopupComponent, {
							centered: true,
							backdrop: 'static'
						});
					} else {
						// subscription not active or expired
						const user = this.authenticationService.getCurrentUser();
						if (user.roles?.includes('Owner')) {
							this.router.navigate(['admin/account/subscription']);
						} else if (!user.roles?.includes('SuperAdmin')) {
							//  if is User
							this.notificationService.showError(
								'Subscription Expired or deactivated please contact support or your account manger',
								'Subscription error'
							);
						}
					}
				}
				if ([403].includes(err.status)) {
					// auto redirect if 403 Forbidden response returned from api
					err.statusText = 'Forbidden';
					let returnRoute = '';
					this.router.navigate([returnRoute]);
				}
				console.log('error : ', err);
				const error = [429].includes(err.status) ? err.error : err.error.message || err.statusText;
				return throwError(error);
			})
		);
	}
}
